export * from './categories.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/categories/index.ts